import React from "react";
import { Box } from "@mui/material";
import { STATUS_STYLES } from "./vpnDebugConstants";
import { VpnDebugRenderStatus } from "./vpnDebugInterfaces";

/**
 * Status pill for one ladder step. Same palette as the tunnel status pill on the
 * Tunnels tab, so green means the same thing on both.
 */
export const VpnDebugStatusPill = ({
  status,
}: {
  status: VpnDebugRenderStatus;
}) => {
  const style = STATUS_STYLES[status] || STATUS_STYLES.pending;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "999px",
        px: 1.25,
        py: 0.4,
        fontFamily: "Mulish",
        fontWeight: 600,
        fontSize: 12,
        backgroundColor: style.backgroundColor,
        color: style.color,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          mr: 0.75,
          boxSizing: "border-box",
          ...(style.dotColor
            ? { backgroundColor: style.dotColor }
            : { border: "2px solid #5f6368" }),
        }}
      />
      {style.label}
    </Box>
  );
};
